// extracted by mini-css-extract-plugin
module.exports = {"w9yuk8m":"w9yuk8m","s1hl5xdc":"s1hl5xdc","e1pvv5x6":"e1pvv5x6","wiggle-e1pvv5x6":"wiggle-e1pvv5x6","b1qlqfpa":"b1qlqfpa"};